const defaultTexts = {
    titleExportData: 'Exportar Informação',
    textExportData: 'Exportação em  execução...',
    finalTextExportData: 'Exportação concluída',
    confirmMsgExportData: 'Pretende exportar a informação?',
    errorMsgExportData:  'Não foi possível exportar a informação',
};
const MethodsExportData = {
    data() {
        return {
            keyOptionsExportData: 'queryParams',
        }
    },
    methods: {
        onExport: function() {
            let options = {...this[this.keyOptionsExportData]};
            if (options.params) {
                options.params["format"] = this.formatExportData;
            }
            this.$root.$emit('openExport', {
                confirmExport: this.confirmExportData,
                confirmMessage: this.confirmMsgExportData,
                title: this.titleExportData,
                text: this.textExportData,
                finalText: this.finalTextExportData,
                urlExport: this.routeExportData,
                urlJob: this.routeJobExportData,
                options: options,
                callback: (data) => { this.onExportCallback(data) },
            });
        },
        onExportCallback: function(data) {
            return;
        }
    }
};
const PropsExportData = {
    props: {
        allowExportData: {
            type: Boolean,
            default: false
        },
        formatExportData: {
            type: String,
            default: 'xls'
        },
        routeExportData: {
            type: String,
            default: null
        },
        routeJobExportData: {
            type: String,
            default: null
        },
        titleExportData: {
            type: String,
            default: defaultTexts.titleExportData
        },
        textExportData: {
            type: String,
            default: defaultTexts.textExportData
        },
        finalTextExportData: {
            type: String,
            default: defaultTexts.finalTextExportData
        },
        confirmMsgExportData: {
            type: String,
            default: defaultTexts.confirmMsgExportData
        },
        errorMsgExportData: {
            type: String,
            default: defaultTexts.errorMsgExportData
        },
        confirmExportData: {
            type: Boolean,
            default: true,
        },
    }
};
const DataExportData = {
    data() {
        return {
            routeExportData: null,
            routeJobExportData: null,
            titleExportData: defaultTexts.titleExportData,
            textExportData: defaultTexts.textExportData,
            finalTextExportData: defaultTexts.finalTextExportData,
            confirmMsgExportData: defaultTexts.confirmMsgExportData,
            errorMsgExportData: defaultTexts.errorMsgExportData,
            allowExportData: false,
            confirmExportData: true,
        }
    },
};



export {MethodsExportData, PropsExportData, DataExportData};